import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './text-image-block.module.scss';
import { TextImageBlockType } from '@/types/text-imgBlock.types';
import FooterButton from '../Footer/components/FooterButton/FooterButton';
import ButtonSimple from '../HeroBlock/components/ButtonSimple/ButtonSimple';

const TextImageBlockCity: NextPage<TextImageBlockType> = ({
  className = '',
  button = 'Group',
  device = 'Desktop',
  imgPosition = 'Right',
  title,
  text,
  image,
  imageMob,
  buttonSimpleText,
  buttonSimpleLink,
  buttonFooterText,
  buttonFooterLink,
  changeSides = false,
  listItems,
  subtitle,
  alt = '',
}) => {
  return (
    <section
      className={[styles.textimageblock, className].join(' ')}
      data-button={button}
      data-device={device}
      data-imgposition={imgPosition}
    >
      <div
        className={`${styles.container} container`}
        data-change-sides={changeSides}
      >
        <section className={styles.text1}>
          {title && (
            <h2
              className={styles.title}
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            ></h2>
          )}
          {subtitle && (
            <h3
              className={styles.subtitle}
              dangerouslySetInnerHTML={{
                __html: subtitle,
              }}
            ></h3>
          )}
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          ></div>
          {listItems && (
            <ul className={styles.list}>
              {listItems.map((item) => (
                <li key={item.id} className={styles.li}>
                  <div className={styles.iconWrapper}>
                    <Image
                      src="/img/text-imgBlock/check-img.png"
                      alt={image}
                      width={24}
                      height={24}
                      quality={85}
                    />
                    {item.title}
                  </div>
                </li>
              ))}
            </ul>
          )}
          <div className={styles.buttongroup}>
            {buttonSimpleText && buttonSimpleLink && (
              <ButtonSimple
                className={styles.submitButton}
                color="accent"
                highContrast
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text={buttonSimpleText}
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                designBlendingMode="/design--blendingmode1.svg"
                designBlendingMode1="/design--blendingmode1.svg"
                href={buttonSimpleLink}
              />
            )}

            {buttonFooterText && buttonFooterLink && (
              <FooterButton
                className={styles.footerButton}
                color="accent"
                highContrast={false}
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text={buttonFooterText}
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                border1={true}
                href={buttonFooterLink}
              />
            )}
          </div>
        </section>
        <Image
          className={styles.imageIcon}
          loading="lazy"
          width={388}
          height={217}
          sizes="(max-width: 768px) 100vw, 50vw"
          alt={alt}
          src={imageMob}
          quality={85}
        />
        <Image
          className={styles.imageIcon1}
          loading="lazy"
          width={1}
          height={1}
          sizes="(max-width: 768px) 100vw, 50vw"
          alt={alt}
          src={image}
          quality={85}
        />
      </div>
    </section>
  );
};

export default TextImageBlockCity;
